import React from 'react';
import HBFileThumbnail from '../HBFileThumbnail/HBFileThumbnail';
import { ThumbnailsWrapper } from './HBFileThumbnail.styles';

export interface IAttachmentFile {
    _id: string;
    cloudinary_public_id?: string;
    isUploading?: boolean;
    name: string;
    type: string;
    url: string;
    isDeleteDisabled?: boolean;
    creator_id?: string;
}

export interface IHBFilesThumbnailsProps {
    /** Files to render as thumbnails. */
    files: IAttachmentFile[];
    /** Shows delete and download action buttons on each thumbnail. */
    isDeletable?: boolean;
    /** Enables selection mode where clicking toggles selection instead of opening a preview. */
    isSelectable?: boolean;
    /** Maximum number of files to display; truncates the list from the end. */
    limitTo?: number;
    /** Called when a thumbnail is clicked; not fired in selection mode. */
    onClickThumbnail?: (file: IAttachmentFile) => void;
    /** Called when a thumbnail's delete action is clicked. */
    onDeleteFile?: (file: IAttachmentFile) => void;
    /** Called when a thumbnail's download action is clicked. */
    onDownloadFile?: (file: IAttachmentFile) => void;
    /** Files currently selected; determines selection state and position badges on each thumbnail. */
    selectedFiles?: IAttachmentFile[];
    /** Custom tooltip text shown on the delete action button of each thumbnail. */
    deleteTooltipText?: string;
}

const HBFilesThumbnails = ({
    files = [],
    isDeletable = false,
    isSelectable = false,
    limitTo,
    onDeleteFile,
    onDownloadFile,
    onClickThumbnail,
    selectedFiles = [],
    deleteTooltipText
}: IHBFilesThumbnailsProps) => {
    const isFileSelected = (fileId: string): boolean => {
        return selectedFiles.some(file => file._id === fileId);
    };

    const assetPositionInSelectedAssets = (file: IAttachmentFile): number => {
        let counter = 0;
        for (const i in selectedFiles) {
            const fileToAttach = selectedFiles[i];

            if (fileToAttach.type !== 'CoverImage') {
                counter++;
            }

            if (fileToAttach._id === file._id) {
                return counter;
            }
        }
        return -1;
    };

    const filesToDisplay = limitTo ? files.slice(0, limitTo) : files;

    const _onDownload = (file: IAttachmentFile) => {
        window.location.href = file.url;
        onDownloadFile?.(file);
    };

    return (
        <ThumbnailsWrapper>
            {Array.isArray(filesToDisplay) &&
                filesToDisplay.map((file, index) => (
                    <HBFileThumbnail
                        key={file._id || index}
                        file={file}
                        isDeletable={isDeletable}
                        isSelectable={isSelectable}
                        isSelected={isFileSelected(file._id)}
                        selectedPosition={assetPositionInSelectedAssets(file)}
                        onClickThumbnail={onClickThumbnail}
                        onDeleteFile={onDeleteFile}
                        onDownloadFile={_onDownload}
                        deleteTooltipText={deleteTooltipText}
                    ></HBFileThumbnail>
                ))}
        </ThumbnailsWrapper>
    );
};

export default HBFilesThumbnails;
